import { CarouselButtons, Stack, XStack, useCarousel } from '@my/ui'
import { ContentCarouselBlock } from './content-carousel.block'
import { ContentCarouselItem } from './content-carousel-item'

export const ContentCarouselComponent = (block: ContentCarouselBlock) => {
  const carousel = useCarousel()
  return (
    <Stack
      position="relative"
      className="overflow-x-hidden"
      py="$3"
      my="$-3"
      w="100%"
      ref={carousel.emblaRef as any}
    >
      <XStack gap="$3.5" height="auto">
        {block.items &&
          block.items.map((item) => (
            <Stack key={item.id} w="90%" $gtXss={{ w: 'calc(50% - 8px)' }}>
              <ContentCarouselItem item={item} imagePriority={block.imagePriority} />
            </Stack>
          ))}
      </XStack>
      <CarouselButtons carousel={carousel} />
    </Stack>
  )
}
